// extracted by mini-css-extract-plugin
export default {"column":"HealthHistory_column__+Cxum","loading":"HealthHistory_loading__pwCnM"};